import React from 'react'
import style from './banner.mod.scss'
import Img from 'gatsby-image'
import { Button, ScrollDown } from '@components'

const Banner = ({
  banner,
  heading = null,
  link,
  caption,
  showScrollDown = false,
  offset = false
}) => {
  const modifiers = []

  offset && modifiers.push(`${style.banner}--offset`)

  return (
    <div className={[style.banner, ...modifiers].join(' ')}>
      <div className={style.banner__wrap}>
        <div className={style.banner__image}>
          <Img fluid={banner} loading={'eager'} />
        </div>
        {(heading || caption || link?.link?.path || link?.url) && (
          <div className={style.banner__heading}>
            {heading && (
              <div
                className={style.banner__main}
                dangerouslySetInnerHTML={{ __html: heading }}
              />
            )}
            {caption && <p>{caption}</p>}
            {(link?.link?.path || link?.url) && (
              <Button
                to={link?.link?.path || link?.url}
                children={link.displayText}
              />
            )}
            {showScrollDown && (
              <div className={style.banner__scroll}>
                <ScrollDown element={'#intro'} type="id" />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default Banner
